import type { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export type AiBadgeProps = {
  style?: CSSProperties;
  className?: string;
};

export default function AiBadge({ style, className }: AiBadgeProps) {
  return (
    <span style={style} className={twMerge(classes.badge, className)}>
      AI
    </span>
  );
}
